var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.745 10.9l4.981-2.804a.5.5 0 000-.871L8.746 4.42A.5.5 0 008 4.855v5.61a.5.5 0 00.745.436z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.92 0 4.87.316.845.949A1 1 0 000 1.937v11.3a1 1 0 00.844.987c4.013.632 7.065.948 9.156.948s5.143-.316 9.156-.948a1 1 0 00.844-.988V2.794A2 2 0 0018.299.817C14.695.272 11.929 0 10 0zm8.333 12.765c-2.773.52-5.57.782-8.333.782-2.762 0-5.56-.263-8.333-.782V2.407A45.386 45.386 0 0110 1.626c2.762 0 5.56.262 8.333.781v10.358z"
  }))));
}
export default SvgVideoIcon;